/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Webauthn_Public_Key_InvalidInputs */



/**
* | output |
* | --- |
* | "This device sent a passkey that oneAI cannot read. The passkey was not saved — please try again, or use a different device or browser." |
*
* @param {Auth_Webauthn_Public_Key_InvalidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_webauthn_public_key_invalid = /** @type {((inputs?: Auth_Webauthn_Public_Key_InvalidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Webauthn_Public_Key_InvalidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Gerät hat einen Passkey gesendet, den oneAI nicht lesen kann. Der Passkey wurde nicht gespeichert – bitte versuche es erneut oder verwende ein anderes Gerät oder einen anderen Browser.")
	return /** @type {LocalizedString} */ ("This device sent a passkey that oneAI cannot read. The passkey was not saved — please try again, or use a different device or browser.")
});